// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ywgI","bigColWidth":"Table_bigColWidth__12Ebe","biggerColWidth":"Table_biggerColWidth__3GVZS","row":"Table_row__pl897","col":"Table_col__2ECkJ"};